<div class="page full-height gray-font-color font-family bodyBackground">
  <div class="header-navigation-back ">
    <mat-icon data-test="back-arrow-icon" (click)="navigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">Shipment Details</span>
    @if (pageType !== 'history') {
    <button mat-button class="header-action-button">
      <mat-icon svgIcon="ellipses" data-test="more" [matMenuTriggerFor]="addmenu"></mat-icon>
    </button>
    }
    <div>
      <mat-menu #addmenu="matMenu" class="button-menu-container" xPosition="after">
        <button mat-menu-item (click)="navigateToDocuments()" class="menu-button">
          Documents
        </button>
        <mat-divider class="divider-class"></mat-divider>
        <button mat-menu-item (click)="navigateToMyStatus()" class="menu-button">
          Status
        </button>
      </mat-menu>
    </div>
  </div>
  @if (isContentReady) {
  <div class="full-height margin-bottom-md header">
    <div class="section">
      <div class="shipment-meta-container">
        <div class="shipment-id-container">
          <div class="shipment-id">{{ shipment.shipmentID || '-' }}</div>
          <br />
          @if (!isConfirmationPending) {
          <div class="shipment-type">{{ this.shipmentType }}</div>
          }
        </div>
        <div class="shipment-status-container">
          <div [ngClass]="[getShipmentStatusClass(), 'status-tag']">
            {{ shipment.status === 'out for delivery' ? 'In Transit' : shipment.status | titlecase }}
          </div>
        </div>
      </div>
      <div class="route-container">
        <div class="route-section">
          <div class="route-visual">
            <div class="route-point from-point">
              <mat-icon class="route-icon">radio_button_checked</mat-icon>
            </div>
            <div class="route-line"></div>
            <div class="route-point to-point">
              <mat-icon class="route-icon">location_on</mat-icon>
            </div>
          </div>
          <div class="route-info">
            <div class="route-location">
              <span class="location-label">From</span>
              <div class="location-city">{{ pickupAddress.updatedOrigin || '-' }}</div>
              <div class="location-address">{{ pickupAddress.updatedStreetAddress || '-' }}</div>
              <div class="location-datetime">{{ pickupAddress.updatedPickupDate || '-' }}, {{
                pickupAddress.updatedPickupTime || '-' }}</div>
            </div>
            <div class="route-location">
              <span class="location-label">To</span>
              <div class="location-city">{{ deliveryAddress.updatedDestination || '-' }}</div>
              <div class="location-address">{{ deliveryAddress.updatedStreetAddress || '-' }}</div>
              <div class="location-datetime">{{ deliveryAddress.updatedDeliveryDate || '-' }}, {{
                deliveryAddress.updatedDeliveryTime || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
  <mat-divider class="margin-bottom-sm"></mat-divider>
  <div class="detail-panel-body no-scroll margin-top-md">
    @if (isContentReady) {
    <div class="sub-detail-content">
      <div class="shipment-meta-details">
        <div class="detail-row">
          <div>
            <div>
              <mat-icon svgIcon="truck" class="text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Unit</div>
              <div class="detail-value">
                {{ mainUnitNumber || '-' }}
              </div>
            </div>
          </div>
          <div>
            <div>
              <mat-icon svgIcon="trailer" class="grey-icon text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Trailer</div>
              <div class="detail-value"> {{
                shipment.trailers
                ? shipment.trailers.length === 0
                ? '-'
                : shipment.trailers.length === 1
                ? shipment.trailers[0].unitNumber
                : '1+'
                : '-'
                }}</div>
            </div>
          </div>
          <div>
            <div>
              <mat-icon svgIcon="trailer" class="text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Load Size</div>
              <div class="detail-value">
                {{ loadTypeMap[shipment.loadType] || '-' }}
              </div>
            </div>
          </div>
        </div>
        <div class="detail-row">
          <div>
            <div>
              <mat-icon svgIcon="weight-scale" class="text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Weight</div>
              <div class="detail-value">
                {{ shipment.weight ? shipment.weight : '-' }}
                <span>{{ shipment.weightUnit ? shipment.weightUnit : '' }}</span>
              </div>
            </div>
          </div>
          <div>
            <div>
              <mat-icon svgIcon="pin-distance" class="grey-icon text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Miles</div>
              <div class="detail-value">{{ shipment.distance ? shipment.distance + 'Miles' : '-' }}</div>
            </div>
          </div>
          <div>
            <div>
              <mat-icon svgIcon="arrow-up-down-line" class="text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">DH-O/DH-D</div>
              <div class="detail-value">
                {{ shipment.deadHeadOrigin ? shipment.deadHeadOrigin + ' Miles' : '-' }}/{{
                shipment.deadHeadDestination ? shipment.deadHeadDestination + ' Miles' : '-'
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="detail-row">
          <div>
            <div>
              <mat-icon svgIcon="money-dollar-circle-line" class="grey-icon text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Rate</div>
              @if (shipment.rateVisibility !== false) {
              <div class="detail-value">
                {{ shipment.offerRate ? '$' + (shipment.offerRate | number) : '-' }}
                @if (shipment.rateCurrency) {
                <span class="currency-txt">{{ shipment.rateCurrency | uppercase }}</span>
                }
              </div>
              } @else {
              -
              }
            </div>
          </div>
          <div>
            <div>
              <mat-icon svgIcon="money-dollar-circle-line" class="grey-icon text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Rate per mile</div>
              @if (shipment.rateVisibility !== false) {
              <div class="detail-value">
                {{ shipment.offerRate ? '$' + (shipment.offerRate | number) : '-' }}
                @if (shipment.rateCurrency) {
                <span class="currency-txt">{{ shipment.rateCurrency | uppercase }}</span>
                }
              </div>
              } @else {
              -
              }
            </div>
          </div>
          <div>
            <div>
              <mat-icon svgIcon="inbox-line" class="text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Commodity</div>
              <div class="detail-value">{{ getCommoditiesName(shipment.commodity) || '-' }}</div>
            </div>
          </div>
        </div>
        <div class="detail-row">
          <div>
            <div>
              <mat-icon svgIcon="truck-line" class="text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Load Size</div>
              <div class="detail-value">{{ shipment.loadSize || '-' }}</div>
            </div>
          </div>
          <div>
            <div>
              <mat-icon svgIcon="ruler-line" class="text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Length</div>
              <div class="detail-value">{{ shipment.length || '-' }}</div>
            </div>
          </div>
          <div>
            <div>
              <mat-icon svgIcon="temp-cold-line" class="text-align-center"></mat-icon>
            </div>
            <div>
              <div class="detail-title">Temperature</div>
              <div class="detail-value">{{ shipment?.temperature ? shipment?.temperature + '&#8457;' : 'N/A' }}</div>
            </div>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
      @if (shipment.pickDropType !== 'sequence') {
      <div>
        <div class="pickup-details">
          <div class="header">
            Pickup instructions
          </div>
          @if (pickupInstructionChips?.length) {
          <div>
            @for (chip of pickupInstructionChips; track chip) {
            <div class="driver-chipset">{{ chip }}</div>
            }
          </div>
          }
          <div class="instruction">
            {{ shipment.pickup.instructions || 'none' }}
          </div>
          <div class="contact-info-container">
            <div fxLayoutGap="5px">
              <div fxFlex="40">
                <div class="contact-tag">Business Name</div>
                <div class="contact-value">{{ shipment.pickup.businessName || '-' }}</div>
              </div>
              <div>
                <div class="contact-tag">Contact name</div>
                <div class="contact-value">{{ shipment.pickup.contactName || '-' }}</div>
              </div>
            </div>
            <div fxLayoutGap="5px">
              <div fxFlex="40">
                <div class="contact-tag">Contact email</div>
                <div class="contact-value">{{ shipment.pickup.contactEmail || '-' }}</div>
              </div>
              <div>
                <div class="contact-tag">Contact phone</div>
                <div class="contact-value">{{ shipment.pickup.contactPhone || '-' }}</div>
              </div>
              <div>
                <button class="contact-icon" [disabled]="!shipment.pickup?.contactPhone">
                  <a [href]="'tel:' + '+1' + shipment.pickup?.contactPhone">
                    <mat-icon svgIcon="phonecall"></mat-icon>
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="delivery-details">
          <div class="header">
            Delivery instructions
          </div>
          @if (deliveryInstructionChips?.length) {
          <div>
            @for (chip of deliveryInstructionChips; track chip) {
            <div class="driver-chipset">{{ chip }}</div>
            }
          </div>
          }
          <div class="instruction">
            {{ shipment.delivery.instructions || 'none' }}
          </div>
          <div class="contact-info-container">
            <div fxLayoutGap="5px">
              <div fxFlex="40">
                <div class="contact-tag">Business Name</div>
                <div class="contact-value">{{ shipment.delivery.businessName || '-' }}</div>
              </div>
              <div>
                <div class="contact-tag">Contact name</div>
                <div class="contact-value">{{ shipment.delivery.contactName || '-' }}</div>
              </div>
            </div>
            <div fxLayoutGap="5px">
              <div fxFlex="40">
                <div class="contact-tag">Contact email</div>
                <div class="contact-value">{{ shipment.delivery.contactEmail || '-' }}</div>
              </div>
              <div>
                <div class="contact-tag">Contact phone</div>
                <div class="contact-value">{{ shipment.delivery.contactPhone || '-' }}</div>
              </div>
              <div>
                <button class="contact-icon" [disabled]="!shipment.delivery?.contactPhone">
                  <a [href]="'tel:' + '+1' + shipment.delivery?.contactPhone">
                    <mat-icon svgIcon="phonecall"></mat-icon>
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
      @if (shipment.pickDropType === 'sequence') {
      <div>
        <app-shipments-stops [readOnly]="true">
        </app-shipments-stops>
      </div>
      }
    </div>
    }
  </div>
</div>